/**
 * Coupon validators - Coupon code and redemption related types
 */
import { Infer, v } from 'convex/values';

// ============================================================================
// Coupon Redemption Status
// ============================================================================

export const couponRedemptionStatusValidator = v.union(
  v.literal('reserved'),
  v.literal('consumed'),
  v.literal('released'),
  v.literal('voided')
);

export type CouponRedemptionStatus = Infer<typeof couponRedemptionStatusValidator>;

export const COUPON_REDEMPTION_STATUSES = ['reserved', 'consumed', 'released', 'voided'] as const;

// ============================================================================
// Coupon Error Reasons (KTD-9 sentinels, shared by backend validators and frontend)
// ============================================================================

export const couponErrorReasonValidator = v.union(
  v.literal('COUPON_ERROR_INVALID'),
  v.literal('COUPON_ERROR_EXPIRED'),
  v.literal('COUPON_ERROR_INACTIVE'),
  v.literal('COUPON_ERROR_MAX_REDEMPTIONS'),
  v.literal('COUPON_ERROR_ALREADY_REDEEMED'),
  v.literal('COUPON_ERROR_SEPA_UNSUPPORTED')
);

export type CouponErrorReason = Infer<typeof couponErrorReasonValidator>;
